import * as SeparatorPrimitive from '@radix-ui/react-separator';
import * as React from 'react';
import { cn } from '@/lib/cn';
const Separator = React.forwardRef<React.ElementRef<typeof SeparatorPrimitive.Root>, React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>>(({
  className,
  orientation = 'horizontal',
  decorative = true,
  ...props
}, ref) => <SeparatorPrimitive.Root ref={ref} decorative={decorative} orientation={orientation} className={cn('shrink-0 self-stretch bg-neutral-muted-border', orientation === 'horizontal' ? 'h-[0.25px]' : 'w-[0.25px]', className)} {...props} />);
Separator.displayName = SeparatorPrimitive.Root.displayName;
export { Separator };